import { useSubmitByEnter } from '@libs/hooks';
import { selectSubmitWidget, useAppSelector } from '@libs/store';
import React from 'react';
import stylis from './pageWrapper.module.css';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    const submitWidget = useAppSelector(selectSubmitWidget);
    const handleKeyDown = useSubmitByEnter(submitWidget);

    return (
        <div className={stylis.pageWrapper} onKeyDown={handleKeyDown}>
            {children}
        </div>
    );
};
